import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=3af53c37&scoped=true&"
import script from "./changePassword.vue?vue&type=script&lang=js&"
export * from "./changePassword.vue?vue&type=script&lang=js&"
import style0 from "./changePassword.vue?vue&type=style&index=0&lang=less&"
import style1 from "./changePassword.vue?vue&type=style&index=1&id=3af53c37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af53c37",
  null
  
)

export default component.exports